
import 'pages/products/groups/group-new-modal.tag'
import 'components/catalog-tree.tag'
riot.tag2('groups-list', '  <catalog-tree object="Category" label-field="{&quot;name&quot;}" children-field="{&quot;childs&quot;}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" dblclick="{handlers.open}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" handlers="{handlers}" allselect="true" reload="true" search="true" reorder="true" observable-trigger="categories-reload">\n    <yield to="head">\n      <button class="btn btn-primary" if="{selectedCount &gt; 1}" type="button" title="Мультиредактирование категорий" onclick="{handlers.multiEdit}"><i class="fa fa-pencil"></i></button>\n    </yield>\n    <yield to="after"><span>{this[parent.childrenField].length ? ⁗[⁗ + this[parent.childrenField].length + ⁗]⁗ : ⁗⁗}</span><span class="col-code">{parent.childrenField.codeGr}</span>\n      <form class="form-inline pull-right">\n\n        <i class="fa fa-plus text-success" title="Добавить категорию" if="{handlers.checkPermission(&quot;products&quot;, &quot;0100&quot;)}" onclick="{handlers.add}" style="margin-right: 10px;"></i>\n      </form>\n    </yield>\n  </catalog-tree>\n', 'groups-list,[riot-tag="groups-list"],[data-is="groups-list"]{ position: relative; display: block; } groups-list treenodes .treenode,[riot-tag="groups-list"] treenodes .treenode,[data-is="groups-list"] treenodes .treenode{ width: 100%; display: inline-block; line-height: 2.2; }', '', function(opts) {
'use strict';

var _this2 = this;

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Category';

self.add = function (e) {
    e.stopPropagation();

    var id, item;
    if (e.item && e.item.id) {
        id = e.item.id;
        item = e.item;
    }

    modals.create('group-new-modal', {
        type: 'modal-primary',
        submit: function submit() {
            var _this = this;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (_this.name.value.toString().trim() != '' && !_this.error) {

                var params, sortIndex, childs;

                if (item) {
                    sortIndex = item['childs'].length;
                    item['childs'] = item['childs'] || [];
                    childs = item['childs'];
                } else {
                    sortIndex = self.tags['catalog-tree'].nodes.length;
                    self.tags['catalog-tree'].nodes = self.tags['catalog-tree'].nodes || [];
                    childs = self.tags['catalog-tree'].nodes;
                }

                if (id) params = { name: _this.name.value, upid: id, sortIndex: sortIndex };else params = { name: _this.name.value, sortIndex: sortIndex };

                API.request({
                    object: 'Category',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        if (e.item && e.item.id) {
                            Object.defineProperty(response, '__parent__', {
                                writable: true,
                                configurable: true,
                                enumerable: false,
                                value: e.item
                            });
                            childs.push(response);
                            self.tags['catalog-tree'].update();
                        } else {
                            observable.trigger('categories-reload');
                        }
                        _this.modalHide();
                        popups.create({
                            title: 'Успех!',
                            text: 'Категория добавлена',
                            style: 'popup-success'
                        });
                        //self.tags['catalog-tree'].update()
                        //observable.trigger('categories-reload')
                    }
                });
            }
        }
    });
};

self.removeNode = function (e) {
    e.stopPropagation();
    var self = _this2,
        params = { ids: [e.item.id] };

    modals.create('bs-alert', {
        type: 'modal-danger',
        title: 'Предупреждение',
        text: 'Вы точно хотите удалить эту запись?',
        size: 'modal-sm',
        buttons: [{ action: 'yes', title: 'Удалить', style: 'btn-danger' }, { action: 'no', title: 'Отмена', style: 'btn-default' }],
        callback: function callback(action) {
            if (action === 'yes') {
                API.request({
                    object: 'Category',
                    method: 'Delete',
                    data: params,
                    success: function success(response) {
                        if (e.item.__parent__ instanceof Array) {
                            e.item.__parent__.splice(e.item.__parent__.indexOf(e.item), 1);
                        } else if (e.item.__parent__ instanceof Object) {
                            e.item.__parent__['childs'].splice(e.item.__parent__['childs'].indexOf(e.item), 1);
                        }

                        popups.create({ title: 'Успешно удалено!', style: 'popup-success' });
                        self.tags['catalog-tree'].update();
                    }
                });
            }
            this.modalHide();
        }
    });
};

function open(e) {
    e.stopPropagation();
    riot.route('/products/categories/' + e.item.id);
}

function multiEdit(e) {
    var ids = this.tags.treeview.getSelectedNodes().map(function (item) {
        return item.id;
    }).join(',');
    riot.route('/products/categories/multi?ids=' + ids);
}

function afterChangeParent(idParent, id, position) {
    var params = {};
    params.id = id;
    params.upid = idParent;
    params.position = position;

    API.request({
        object: 'Category',
        method: 'Save',
        data: params,
        success: function success() {
            popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
        }
    });
}

function afterChangePosition(indexes) {
    var params = { indexes: indexes };
    API.request({
        object: 'Category',
        method: 'Sort',
        data: params,
        success: function success() {
            popups.create({ title: 'Успех!', text: 'Изменения сохранены!', style: 'popup-success' });
        }
    });
}

self.handlers = {
    checkMask: self.checkMask,
    checkPermission: self.checkPermission,
    permission: self.permission,
    add: self.add,
    open: open,
    remove: self.removeNode,
    multiEdit: multiEdit,
    afterChangeParent: afterChangeParent,
    afterChangePosition: afterChangePosition
};

observable.on('categories-reload', function (item) {
    if (item == undefined) {
        self.tags['catalog-tree'].reload();
    } else {
        var items = self.tags['catalog-tree'].tags.treeview.getSelectedNodes();
        items[0].name = item.name;
    }
});
});


// WEBPACK FOOTER //
// ./pages/products/groups/groups-list.tag